import { themeGQLFields } from './theme.fields.js';
const BASIC_THEME_FIELDS = {
    active: 'basic',
    drafts: 'basic',
    published: 'basic',
};
const ALL_THEME_FIELDS = {
    active: 'all',
    drafts: 'all',
    published: 'all',
};
export function themesGQLFields(fields) {
    if (fields === 'basic')
        fields = BASIC_THEME_FIELDS;
    if (fields === 'all')
        fields = ALL_THEME_FIELDS;
    return `
    __typename
    ${fields.active
        ? `
      active {
        ${themeGQLFields(fields.active)}
      }
    `
        : ``}
    ${fields.drafts
        ? `
      drafts {
        ${themeGQLFields(fields.drafts)}
      }
    `
        : ``}
    ${fields.published
        ? `
      published {
        ${themeGQLFields(fields.published)}
      }
    `
        : ``}
  `;
}
//# sourceMappingURL=themes.fields.js.map